<template>
    <a-form
        layout="horizontal"
    >   
        
        <a-form-item
            v-bind="formItemLayout"
        >
            <h3
                slot="label"
            >
                {{ label }}
            </h3>
            <a-select
                mode="multiple"
                :labelInValue="true"
                v-model="selectedOptions"
                placeholder="Válasszon vagy kezdjen gépelni"
            >
                <a-select-option 
                    v-for="option in options"
                    :key="option.value" 
                    :value="option.value"
                >
                    {{ option.label }}
                </a-select-option>
            </a-select>
        </a-form-item>    
    </a-form>
</template>

<script>
export default {
    name: 'SearchSelect',
    props: {
        label: String,
        options: Array,
        selected: Array
    },
    model: {
        prop: 'selected',
        event: 'selectionChange'
    },

    data() {
        return {
            formItemLayout: {
                labelCol: { span: 24 },
                wrapperCol: { span: 24 }
            },
        }
    },

    computed: {
        selectedOptions: {
            get() {
                return this.selected
            }, 
            set(val) {
                this.selectionChange(val);
            }
        }
    },

    methods: {
        selectionChange(value) {
            this.$emit('selectionChange', value)
        },

    }
}
</script>

<style lang="scss" scoped>

</style>